import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Modal,
  TextField,
  IconButton,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  CssBaseline,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { Edit, Delete, CheckCircle, Cancel, Group, Menu, Security, Search as SearchIcon } from '@mui/icons-material'; // Importar Security icon
import Sidebar from './Sidebar'; 
import api from '../api/api';

// --- ESTILOS MEJORADOS ---
const drawerWidth = 20; 
const PRIMARY_DARK_BG = '#1e293b'; 
const MAIN_BG = '#f1f5f9'; 

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    email_usuario: '',
    nombre_usuario: '',
    password_usuario: '',
    id_rol: '',
    id_sucursal: '',
    id_pet: '',
  });
  const [roles, setRoles] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [error, setError] = useState('');
  const [openSidebar, setOpenSidebar] = useState(true);
  const [showDisabled, setShowDisabled] = useState(false); 
  
  const [searchTerm, setSearchTerm] = useState('');
  
  // --- NUEVOS ESTADOS PARA EL MODAL DE TOKEN ROBOT ---
  const [openRobotTokenModal, setOpenRobotTokenModal] = useState(false);
  const [robotToken, setRobotToken] = useState(null);
  // --------------------------------------------------

  // --- LÓGICA DE CARGA DE USUARIOS ---
  const fetchUsuarios = async (fetchDisabled = false) => {
    // ... (la función fetchUsuarios no necesita cambios)
    try {
      let endpoint = '/usuarios/'; 
      if (fetchDisabled) {
        endpoint = '/usuarios/deshabilitados'; 
      }
      
      const usuariosResponse = await api.get(endpoint);
      setUsuarios(usuariosResponse.data || []);
      setError('');
    } catch (err) {
      console.error('Error al cargar usuarios:', err.response?.data || err.message);
      setUsuarios([]);
      let errorMessage = 'Error al cargar usuarios'; 
      if (Array.isArray(err.response?.data?.detail)) {
        const errorMessages = err.response.data.detail.map((e) => 
          `${e.loc.join('.')}: ${e.msg}`
        ).join('; ');
        errorMessage = errorMessages || 'Error de validación desconocido';
      } else if (err.response?.data?.detail) {
        errorMessage = err.response.data.detail;
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
    }
  };

  useEffect(() => {
  const fetchData = async () => {
    try {
      // ←←← Ahora usa la nueva función que decodifica el token
      await fetchCurrentUser();

      await fetchUsuarios(showDisabled);

      const rolesResponse = await api.get('/roles/');
      setRoles(rolesResponse.data || []);

      const sucursalesResponse = await api.get('/sucursales/');
      setSucursales(sucursalesResponse.data || []);

    } catch (err) {
      console.error('Error al cargar datos:', err.response?.data || err.message);
      setError(err.response?.data?.detail || 'Error al cargar datos');
    }
  };
  fetchData();
}, [showDisabled]);

  // ... (handleDrawerToggle, handleFilterChange, handleOpen, handleClose, handleChange, handleSubmit, handleToggleHabilitado, handleToggleDelegado, formatDate, handleDelete permanecen igual)
  
  const handleDrawerToggle = () => {
    setOpenSidebar(!openSidebar);
  };

  const handleFilterChange = (event) => {
    setShowDisabled(event.target.checked);
  };

  const handleOpen = (usuario = null) => {
    setEditId(usuario?.id_usuario || null);
    setFormData({
      email_usuario: usuario?.email_usuario || '',
      nombre_usuario: usuario?.nombre_usuario || '',
      password_usuario: '',
      id_rol: usuario?.id_rol || '',
      id_sucursal: usuario?.id_sucursal || '',
      id_pet: usuario?.id_pet || currentUser?.id_pet || 1,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({ email_usuario: '', nombre_usuario: '', password_usuario: '', id_rol: '', id_sucursal: '', id_pet: '' });
    setEditId(null);
    setError('');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // --- FUNCIÓN MEJORADA: Decodifica token + carga nombre de veterinaria ---
const fetchCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    let user = null;

    // 1. Decodificar token (igual que en LogisticaDomicilio)
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('[Usuarios] Token decodificado:', payload);

        user = {
          id_usuario: payload.id_usuario,
          id_rol: payload.id_rol,
          id_pet: payload.id_pet,
          email_usuario: payload.email_usuario,
          nombre_usuario: payload.nombre_usuario,
          // Agrega aquí otros campos que vengan en tu token
        };
      } catch (decodeErr) {
        console.error('[Usuarios] Error decodificando token:', decodeErr);
      }
    }

    // 2. Si no pudimos decodificar o queremos datos frescos → fallback al endpoint
    if (!user || !user.id_pet) {
      const isLoginResponse = await api.get('/usuarios/auth/is-login/');
      user = isLoginResponse.data;
    }

    // 3. Cargar nombre_veterinaria desde /pets/{id_pet}
    if (user?.id_pet) {
      try {
        const petResponse = await api.get(`/pets/${user.id_pet}`);
        user = {
          ...user,
          nombre_veterinaria: petResponse.data.nombre_veterinaria,
        };
      } catch (petErr) {
        console.warn('[Usuarios] No se pudo cargar nombre_veterinaria:', petErr);
      }
    }

    setCurrentUser(user || { id_pet: 1 });
  } catch (err) {
    console.error('[Usuarios] Error al cargar usuario actual:', err);
    setCurrentUser({ id_pet: 1 });
  }
};


const filteredUsuarios = usuarios.filter(user => {
  if (!searchTerm) return true;
  const term = searchTerm.toLowerCase();
  return (
    user.nombre_usuario?.toLowerCase().includes(term) ||
    user.email_usuario?.toLowerCase().includes(term)
  );
});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const usuarioEnEdicion = editId ? usuarios.find(u => u.id_usuario === editId) : null;
    const isTitularEnEdicion = usuarioEnEdicion ? usuarioEnEdicion.es_titular : false;

    // 1. Validaciones
    if (!editId && !formData.password_usuario) {
      setError('La contraseña es obligatoria al crear un usuario');
      return;
    }
    if (!formData.email_usuario || !formData.nombre_usuario || !formData.id_rol || !formData.id_pet) {
      setError('Faltan campos obligatorios.');
      return;
    }

    // 2. Separación de datos
    const { password_usuario, id_sucursal, ...mainData } = formData;
    const password = password_usuario;
    
    const mainDataToSend = {
      ...mainData,
      id_rol: Number(mainData.id_rol),
      id_pet: Number(mainData.id_pet || currentUser?.id_pet || 1),
      id_sucursal: id_sucursal ? Number(id_sucursal) : null,
    };

    try {
      if (editId) {
        await api.put(`/usuarios/${editId}`, mainDataToSend);
        if (password) {
          if (isTitularEnEdicion) {
            setError('Error: La contraseña de un usuario titular no puede ser modificada.');
            return;
          }
          const passwordPayload = { password_usuario: password };
          await api.put(`/usuarios/${editId}/password`, passwordPayload);
          setFormData(prev => ({ ...prev, password_usuario: '' }));
        }
      } else {
        const dataToCreate = { ...mainDataToSend, password_usuario: password };
        await api.post('/usuarios/', dataToCreate);
      }

      await fetchUsuarios(showDisabled);
      handleClose();
      
    } catch (err) {
      console.error('Error al guardar usuario:', err.response?.data || err.message);
      let errorMessage = 'Error al guardar usuario'; 
      if (Array.isArray(err.response?.data?.detail)) {
        const errorMessages = err.response.data.detail.map((e) => 
          `${e.loc.join('.')}: ${e.msg}`
        ).join('; ');
        errorMessage = errorMessages || 'Error de validación desconocido';
      } else if (err.response?.data?.detail) {
        errorMessage = err.response.data.detail;
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
    }
  };

  const handleToggleHabilitado = async (id) => {
    try {
      await api.put(`/usuarios/${id}/toggle-habilitado`);
      await fetchUsuarios(showDisabled); 
    } catch (err) {
      console.error('Error al cambiar estado de habilitado:', err.response?.data || err.message);
      setError(err.response?.data?.detail || 'Error al cambiar estado de habilitado');
    }
  };

  const handleToggleDelegado = async (id) => {
    try {
      await api.put(`/usuarios/${id}/toggle-delegado`);
      await fetchUsuarios(showDisabled);
    } catch (err) {
      console.error('Error al cambiar estado de delegado:', err.response?.data || err.message);
      setError(err.response?.data?.detail || 'Error al cambiar estado de delegado');
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Sin fecha';
    const date = new Date(Number(timestamp));
    return date.toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' });
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/usuarios/${id}`);
      await fetchUsuarios(showDisabled);
    } catch (err) {
      console.error('Error al eliminar usuario:', err.response?.data || err.message);
      setError(err.response?.data?.detail || 'Error al eliminar usuario');
    }
  };
  
  // --- NUEVA FUNCIÓN PARA GENERAR TOKEN ROBOT ---
  const handleGenerateRobotToken = async () => {
    try {
      setError('');
      setRobotToken(null);
      const response = await api.get('/usuarios/generar-token-robot/');
      setRobotToken(response.data);
      setOpenRobotTokenModal(true);
    } catch (err) {
      console.error('Error al generar token robot:', err.response?.data || err.message);
      setError(err.response?.data?.detail || 'Error al generar token robot. Asegúrese de estar logueado.');
    }
  };

  const handleCloseRobotTokenModal = () => {
    setOpenRobotTokenModal(false);
    setRobotToken(null);
  };
  // ---------------------------------------------

  const usuarioEnEdicion = editId ? usuarios.find(u => u.id_usuario === editId) : null;
  const isTitularEnEdicion = usuarioEnEdicion ? usuarioEnEdicion.es_titular : false;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      
      {/* APP BAR */}
        <AppBar
        position="fixed"
        sx={(theme) => ({
          width: '100%', 
          ml: 0, 
          zIndex: theme.zIndex.drawer + 1, 
          bgcolor: PRIMARY_DARK_BG,
          transition: theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
          }),
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <Menu />
          </IconButton>
          <Typography variant="h6" noWrap>
            Gestión de Usuarios
          </Typography>
        </Toolbar>
      </AppBar>
      <Sidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
      
      {/* MAIN CONTENT BOX */}
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1, 
          p: 0, 
          minHeight: '100vh', 
          bgcolor: MAIN_BG, 
          display: 'flex',
          flexDirection: 'column',
          marginLeft: { sm: openSidebar ? `${drawerWidth}px` : 0 }, 
          width: { sm: `calc(100% - ${openSidebar ? drawerWidth : 0}px)` },
          transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
          }),
        })}
      >
        <Toolbar /> 
        
        {/* CONTAINER */}
        <Container 
            maxWidth="xl" 
            sx={{ 
                p: 3, 
                mt: 0, 
                mb: 2, 
                flexGrow: 1,
            }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button variant="contained" color="primary" onClick={() => handleOpen()}>
                Crear Usuario
              </Button>
              {/* NUEVO BOTÓN PARA GENERAR TOKEN ROBOT */}
              <Button 
                variant="contained" 
                color="secondary" 
                onClick={handleGenerateRobotToken}
                startIcon={<Security />}
              >
                Generar Token Robot
              </Button>
            </Box>
            {/* Checkbox para filtrar usuarios deshabilitados */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={showDisabled}
                  onChange={handleFilterChange}
                  color="error"
                />
              }
              label={showDisabled ? "Mostrando SOLO Deshabilitados" : "Mostrar solo Deshabilitados"}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <TextField
              variant="outlined"
              size="small"
              placeholder="Buscar por nombre o email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ flexGrow: 1, maxWidth: 400 }}
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
              }}
            />
          </Box>
              {error && typeof error === 'string' && ( 
                <Typography color="error" variant="body2" sx={{ mt: 2 }}>
                    {error} 
                </Typography>
              )}
          
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                {/* ... (TableHead permanece igual) */}
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Rol</TableCell>
                  <TableCell>Sucursal</TableCell>
                  <TableCell>ID Pet</TableCell>
                  <TableCell>Habilitado</TableCell>
                  <TableCell>Es Titular</TableCell>
                  <TableCell>Es Delegado</TableCell>
                  <TableCell>Creado</TableCell>
                  <TableCell>Actualizado</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* ... (TableBody permanece igual) */}
                {filteredUsuarios.map((usuario) => (
                  <TableRow key={usuario.id_usuario} sx={{ backgroundColor: usuario.habilitado ? 'inherit' : '#ffebee' }}>
                    <TableCell>{usuario.id_usuario}</TableCell>
                    <TableCell>{usuario.email_usuario}</TableCell>
                    <TableCell>{usuario.nombre_usuario}</TableCell>
                    <TableCell>
                      {roles.find((rol) => Number(rol.id_rol) === Number(usuario.id_rol))?.descripcion_rol || 'N/A'}
                    </TableCell>
                    <TableCell>{usuario.nombre_sucursales || 'N/A'}</TableCell>
                    <TableCell>{usuario.id_pet}</TableCell>
                    <TableCell>{usuario.habilitado ? 'Sí' : 'No'}</TableCell>
                    <TableCell>{usuario.es_titular ? 'Sí' : 'No'}</TableCell>
                    <TableCell>{usuario.es_delegado ? 'Sí' : 'No'}</TableCell>
                    <TableCell>{formatDate(usuario.createdAt)}</TableCell>
                    <TableCell>{formatDate(usuario.updatedAt)}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpen(usuario)}>
                        <Edit />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(usuario.id_usuario)}>
                        <Delete />
                      </IconButton>
                      <IconButton onClick={() => handleToggleHabilitado(usuario.id_usuario)}>
                        {usuario.habilitado ? <Cancel color="error" /> : <CheckCircle color="success" />}
                      </IconButton>
                      <IconButton onClick={() => handleToggleDelegado(usuario.id_usuario)}>
                        {usuario.es_delegado ? <Group color="primary" /> : <Group color="disabled" />}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Modal para crear/editar (permanece igual) */}
          <Modal open={open} onClose={handleClose}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 420,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" component="h2" gutterBottom>
      {editId ? 'Editar Usuario' : 'Crear Nuevo Usuario'}
    </Typography>

    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      {/* Campos editables */}
      <TextField
        margin="normal"
        required
        fullWidth
        label="Correo Electrónico"
        name="email_usuario"
        value={formData.email_usuario}
        onChange={handleChange}
        autoFocus
      />

      <TextField
        margin="normal"
        required
        fullWidth
        label="Nombre completo"
        name="nombre_usuario"
        value={formData.nombre_usuario}
        onChange={handleChange}
      />

      <TextField
        margin="normal"
        required={!editId}
        fullWidth
        label={editId ? "Contraseña (dejar en blanco para no cambiar)" : "Contraseña"}
        name="password_usuario"
        type="password"
        value={formData.password_usuario}
        onChange={handleChange}
        disabled={editId && isTitularEnEdicion}
        helperText={editId && isTitularEnEdicion ? "La contraseña del titular no puede modificarse" : ""}
      />

      {/* Rol */}
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="rol-label">Rol</InputLabel>
        <Select
          labelId="rol-label"
          name="id_rol"
          value={formData.id_rol}
          label="Rol"
          onChange={handleChange}
        >
          <MenuItem value="">Seleccione un rol</MenuItem>
          {roles.map((rol) => (
            <MenuItem key={rol.id_rol} value={rol.id_rol}>
              {rol.descripcion_rol}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Sucursal (sigue siendo opcional) */}
      <FormControl fullWidth margin="normal" disabled>
        <InputLabel id="sucursal-label">Sucursal</InputLabel>
        <Select
          labelId="sucursal-label"
          name="id_sucursal"
          value={formData.id_sucursal || ''}
          label="Sucursal"
          disabled
        >
          <MenuItem value="">Ninguna / Sin sucursal específica</MenuItem>
          {sucursales.map((suc) => (
            <MenuItem key={suc.id_sucursal} value={suc.id_sucursal}>
              {suc.nombre_sucursal}
            </MenuItem>
          ))}
        </Select>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          La asignación de sucursal se realiza en otro módulo
        </Typography>
      </FormControl>

      {/* ── Campos de solo lectura ── Veterinaria ── */}
      <TextField
        margin="normal"
        fullWidth
        label="Veterinaria asociada"
        value={currentUser?.nombre_veterinaria || `Veterinaria ID ${formData.id_pet || '—'}`}
        InputProps={{
          readOnly: true,
          sx: { 
            backgroundColor: '#f5f5f5',
            fontWeight: 500,
          }
        }}
        variant="outlined"
        helperText="La veterinaria se determina automáticamente según el usuario actual"
        sx={{ 
          '& .MuiInputBase-root': { 
            backgroundColor: '#f5f5f5 !important' 
          },
          '& .MuiFormHelperText-root': {
            color: '#666',
            fontStyle: 'italic',
            mt: 0.5
          }
        }}
      />

      <TextField
        margin="normal"
        required
        fullWidth
        label="ID Pet (Veterinaria)"
        name="id_pet"
        value={formData.id_pet || currentUser?.id_pet || ''}
        type="number"
        InputProps={{
          readOnly: true,
          sx: { 
            backgroundColor: '#f5f5f5',
            fontFamily: 'monospace'
          }
        }}
        variant="outlined"
        helperText="Este valor no se puede modificar"
        sx={{ 
          '& .MuiInputBase-root': { 
            backgroundColor: '#f5f5f5 !important' 
          }
        }}
      />

      {/* Mensaje de error */}
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 2, mb: 1 }}>
          {error}
        </Typography>
      )}

      {/* Botones */}
      <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancelar
        </Button>
        <Button 
          type="submit" 
          variant="contained" 
          color="primary"
          disabled={!formData.email_usuario || !formData.nombre_usuario || !formData.id_rol}
        >
          {editId ? 'Guardar cambios' : 'Crear usuario'}
        </Button>
      </Box>
    </Box>
  </Box>
</Modal>

          {/* --- NUEVO MODAL PARA EL TOKEN ROBOT --- */}
          <Modal open={openRobotTokenModal} onClose={handleCloseRobotTokenModal}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 500,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
              }}
            >
              <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 2 }}>
                🤖 Token de Larga Duración Generado
              </Typography>
              {robotToken ? (
                <>
                  <Typography variant="body1" color="textPrimary" sx={{ mb: 2 }}>
                    Este token es válido por **{robotToken.validez}** y debe usarse para el importador automático.
                    **Cópielo inmediatamente** ya que no se almacenará en el sistema.
                  </Typography>
                  <TextField
                    fullWidth
                    label="Token Robot (Hacer click para copiar)"
                    multiline
                    rows={4}
                    value={robotToken.token_robot}
                    InputProps={{ 
                      readOnly: true,
                      style: { 
                        fontFamily: 'monospace', 
                        backgroundColor: '#f5f5f5' 
                      } 
                    }}
                    onClick={(e) => {
                      navigator.clipboard.writeText(robotToken.token_robot);
                      alert('Token copiado al portapapeles.');
                    }}
                    sx={{ mb: 3 }}
                  />
                  <Typography variant="caption" color="error">
                    {robotToken.mensaje}
                  </Typography>
                  
                </>
              ) : (
                <Typography color="error">
                  Error: No se pudo obtener el token. Verifique su conexión y permisos.
                </Typography>
              )}
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="contained" onClick={handleCloseRobotTokenModal}>
                  Cerrar
                </Button>
              </Box>
            </Box>
          </Modal>
          {/* --------------------------------------------- */}


        </Container>
      </Box>
    </Box>
  );
};

export default Usuarios;